import {
  //   ApiGetRequest,
  ApiPostRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Laporan Arus Kas',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Laporan Arus Kas',
        href: '/adm/fin/laporan/arus-kas',
        active: true,
      },
    ],
    form: {
      periode: '',
    },
    report: [],
    total_keluar_masuk: 0,
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  report(state) {
    return state.data.report;
  }
};

export const mutations = {
  changeArusKas(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getArusKas({ commit, state }) {
    commit('changeArusKas', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`fin/laporan/arus-kas`, data.form);
    commit('changeArusKas', {
      report: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },
};
